import { IAM_CONTRACT, NON_CONTRACT, TWU_CONTRACT, WORKGROUP_MANAGER } from "../constants";

var FlexSearch = require("flexsearch");

var index;

export function initializeSearchIndex(bidGroup) {
  index = new FlexSearch({
    doc: {
      id: "eid",
      profile: "speed",
      field: {
        homeAccountStation: {},
        homeAccountJobCode: {},
        seniorityDate: {},
        first_name: {},
        lastName: {},
        shortName: {},
        birthDate: {},
        hireDate: {},
        rank: {},
        union_code: {},
        pay_method: {},
        adjusted_hire_date: {},
        classificationDate: {},
        contractDate: {},
        dualSeniorityDate: {},
        wnSliSeniorityDate: {},
        flAtlSeniorityDate: {},
        ftpt: {},
      },
    },
  });

  index.add(bidGroup);
}

export function searchBidGroup({ searchString, applySearchCallback, contract, workgroup }) {
  if (index) {
    let result = index.where(
      function (item) {
        if (item.eid?.toLowerCase().includes(searchString)) {
          return true;
        }

        if (item.rank?.toString().includes(searchString)) {
          return true;
        }

        if (item.shortName?.toLowerCase().includes(searchString)) {
          return true;
        }

        if (item.lastName?.toLowerCase().includes(searchString)) {
          return true;
        }

        if (item.ftpt?.toLowerCase().includes(searchString)) {
          return true;
        }

        if (contract === IAM_CONTRACT) {
          if (item.classificationDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.contractDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.hireDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.birthDate?.toLowerCase().includes(searchString)) {
            return true;
          }
        } else if (contract === TWU_CONTRACT) {
          if (item.wnSliSeniorityDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.flAtlSeniorityDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.dualSeniorityDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.hireDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.birthDate?.toLowerCase().includes(searchString)) {
            return true;
          }
        } else if (contract === NON_CONTRACT) {
          if (item.seniorityDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.hireDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (item.birthDate?.toLowerCase().includes(searchString)) {
            return true;
          }

          if (workgroup === WORKGROUP_MANAGER) {
            if (item.jobTitle?.toLowerCase().includes(searchString)) {
              return true;
            }
          }
        } else {
          console.log("error unrecognized contract: ", contract);
        }

        return false;
      },
      (result) => {
        applySearchCallback(searchString, result);
      }
    );
    applySearchCallback(searchString, result);
  }
}
